// extracted by mini-css-extract-plugin
export var calculatorImage = "DedicatedTeam-module--calculator-image--93388";
export var content = "DedicatedTeam-module--content--3cc83";
export var imageBox = "DedicatedTeam-module--image-box--eb273";